module.exports = __webpack_public_path__ + "img/ws_platinum.6ca6614c.png";